import { lazy, Suspense } from 'react';
import { AppShell } from '../components/AppShell';
import { useDesign } from '../lib/design';
import type { ShellProps } from './shellShared';

/** Lazy on purpose: the B/C shells are the only importers of `motion`, so a Classic (design A)
 *  visitor never downloads it — the control arm of the test stays byte-for-byte what it was. */
const LedgerShell = lazy(() => import('./ledger/LedgerShell').then((m) => ({ default: m.LedgerShell })));
const ToyboxShell = lazy(() => import('./toybox/ToyboxShell').then((m) => ({ default: m.ToyboxShell })));

const fallback = <div className="min-h-full bg-bg" />;

/** REV30: picks the app shell for the active design variant (`lib/design.ts`). */
export function DesignShell({ children }: ShellProps) {
  const design = useDesign();

  if (design === 'ledger') {
    return (
      <Suspense fallback={fallback}>
        <LedgerShell>{children}</LedgerShell>
      </Suspense>
    );
  }
  if (design === 'toybox') {
    return (
      <Suspense fallback={fallback}>
        <ToyboxShell>{children}</ToyboxShell>
      </Suspense>
    );
  }
  return <AppShell>{children}</AppShell>;
}
